import React from 'react';
import { connect } from 'react-redux';
import { beginInitUsersTasks } from 'actions';
import { TasksFilters, TaskForm, TaskReminderDateForm } from 'components';
import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';

class TasksSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show_task_form: false,
      show_task_reminder_form: false,
      current_task: null
    };
  }

  componentWillMount() {
    this.props.beginInitUsersTasks();
  }
  componentWillUpdate(next_props) {
    const curr_open = this.props.ui.show_tasks_sidebar;
    const next_open = next_props.ui.show_tasks_sidebar;

    if(curr_open != next_open) {
      $('.tasks-sidebar-container').toggleClass('closed');
    }
  }

  render() {
    const view_task_form = this.state.show_task_form && !this.props.tasks.updating_task;
    const view_task_reminder_form = this.state.show_task_reminder_form && !this.props.updating_task;

    return (
      <div className='tasks-sidebar-container closed'>
        <Row>
          <Col md={12} xs={12}>
            {this.state.show_task_form ? (
              <div className='create-task-toggle'>
                <div onClick={() => this.setState({ show_task_form: false })}>
                  <h4><i className='fa fa-chevron-left task-sidebar-top-button'/>CANCEL</h4>
                </div>
              </div>
            ) : (
              <div className='create-task-toggle'>
                <div onClick={() => this.setState({ show_task_form: true })}>
                  <h4><i className='fa fa-plus task-sidebar-top-button' />CREATE NEW TASK</h4>
                </div>
              </div>
            )}
          </Col>
        </Row>
        {view_task_form ? (
          <TaskForm
            cancel={() => this.setState({ show_task_form: false, show_task_reminder_form: false, current_task: null })}
            task={this.state.current_task}
          />
        ) : view_task_reminder_form ? (
          <TaskReminderDateForm
            cancel={() => this.setState({ show_task_form: false, show_task_reminder_form: false, current_task: null })}
            task={this.state.current_task}
          />
        ) : null}
        <div style={{ display: !view_task_form && !view_task_reminder_form ? 'block' : 'none' }}>
          <TasksFilters
            initEditTask={task => this.setState({ show_task_form: true, show_task_reminder_form: false, current_task: task })}
            initEditReminderDate={task => this.setState({ show_task_reminder_form: true, show_task_form: false, current_task: task })}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ tasks, ui, clients }) => ({ tasks, ui, clients });

export default connect(mapStateToProps, { beginInitUsersTasks })(TasksSidebar);



// WEBPACK FOOTER //
// ./src/browser/components/tasks/new-tasks/tasks-sidebar.js